/**
 * A category is a "leaf" if no other category in the same set names it as a parent.
 * Used by the document filter UI and the admin Attributes table so users only see
 * the bottom-most categories in the hierarchy.
 */
export function filterLeafCategories<T extends { id: number; parent_category_id: number | null }>(
  categories: T[]
): T[] {
  const parentIds = new Set(
    categories.map((c) => c.parent_category_id).filter((id): id is number => id != null)
  );
  return categories.filter((c) => !parentIds.has(c.id));
}
